__turbopack_context__.v({
  "className": "oregano_844691e6-module__vIQFSa__className",
});
